/* eslint-disable */
import Box from '@mui/material/Box';
import '../b2bPage/b2bPage.css';
import './historyPage.css';
import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../redux/api';
import { Container, Row, Col } from 'react-bootstrap';
import { Typography } from '@mui/material';
import {
  AccordionCustom,
  AccordionDetailsCustom,
  AccordionSummaryCustom,
  ExpandMoreIconCustom,
} from '../../components/globalStyles';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { plugTypeMaping } from '../../utils/utils';
import { useGetClientId, getClientAgent, isNativeShellApp } from '../../hookServices/clientId';
import { getEnergyCardClientIdFromInvoice, isEnergyCardInvoiceId } from '../../hookServices/energyCard';
import Spinner from '../../components/loaders/globalSpinner/Spinner';
import { Button, Card, ActionButtonSpinner, getActionButtonLoadingClassName } from '../../shared/ui';
import {
  useGetStationStatusQuery,
  useGetActiveEnergyCardsQuery,
  useNotifyBalanceRecoverClickedMutation,
  useRecoverBalanceFromReceiptMutation,
} from '../../redux/api';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram } from '@fortawesome/free-brands-svg-icons';
import ReactGA from 'react-ga';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { HOST, PORT, TELEGRAM_BOT } from '../../environment';
import RecoverBalanceModal from './RecoverBalanceModal';
import RefundRequestModal from '../startPage/RefundRequestModal';
import ClientIdQrModal from './ClientIdQrModal';
import StopChargingConfirmModal from '../../components/StopChargingConfirmModal';
import HistoryPowerCurve from './HistoryPowerCurve';
import powerCurveStyles from './HistoryPowerCurve.module.css';
import gammaThemeStyles from '../b2bPage/b2bGammaTheme.module.css';
import { HISTORY_CHART_FONT, waitForHistoryChartFonts } from './historyChartFont';
import { createRevenueChartExternalTooltip } from './historyRevenueChartTooltip';
import {
  formatHistoryKwh,
  formatImpactCount,
  formatImpactCo2Tons,
  computeSessionAvgPowerKw,
} from './historyChartImpact';

moment.locale('ua', {
  monthsShort: 'Cіч_Лют_Бер_Кві_Тра_Чер_Лип_Сер_Вер_Жов_Лис_Гру'.split('_'),
});

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
ChartJS.register(ChartDataLabels);

const B2B_GAMMA_FONTS =
  'https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;500;600&family=Inconsolata:wght@700&display=swap';
const REVENUE_CHART_MONTHS = 6;

const REVENUE_CHART_MONTH_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

function getShortMonthLabel(month, t) {
  if (!month) return '';
  const [, monthNum] = month.split('-');
  const monthIndex = parseInt(monthNum, 10) - 1;
  const key = REVENUE_CHART_MONTH_KEYS[monthIndex];
  return key ? t(`monthsShort.${key}`) : '';
}

function getHistorySessionKey(item, index) {
  return (
    item?.chargingJobId ||
    item?.invoiceId ||
    `${item?.plugNumber || 'port'}-${item?.startedOn || item?.createdOn || index}`
  );
}

function formatEnergyCardExpiresOn(expiresOn) {
  if (!expiresOn) return '';
  const d = new Date(expiresOn);
  if (Number.isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}

function isUahEnergyCard(card) {
  return card?.unit === 'UAH';
}

function getEnergyCardFaceKwh(card) {
  const faceKwh = Number.isFinite(card?.totalKwh) ? card.totalKwh : card?.remainingKwh;
  return Number.isInteger(faceKwh) ? String(faceKwh) : Number(faceKwh || 0).toFixed(1);
}

function getEnergyCardFaceUah(card) {
  const faceUah = Number.isFinite(card?.totalUah) ? card.totalUah : card?.remainingUah;
  return Number.isInteger(faceUah) ? String(faceUah) : Number(faceUah || 0).toFixed(2);
}

function getEnergyCardDisplayMeta(card, t) {
  const uah = isUahEnergyCard(card);
  const faceLabel = uah ? getEnergyCardFaceUah(card) : getEnergyCardFaceKwh(card);
  const rawName = typeof card?.name === 'string' ? card.name.trim() : '';
  // Legacy rows stored the funny id in `name`; prefer branded/custom title for display.
  const nameLooksLikeId = Boolean(rawName) && !/\s/.test(rawName) && rawName.includes('_');
  const displayName =
    (rawName && !nameLooksLikeId ? rawName : null) ||
    (uah ? t('energyCard.brandedNameUah', { uah: faceLabel }) : t('energyCard.brandedName', { kwh: faceLabel }));
  const cardId = (typeof card?.publicId === 'string' && card.publicId.trim()) || (nameLooksLikeId ? rawName : null);
  return { displayName, cardId };
}

function energyCardCreatedMs(card) {
  if (card?.createdOn) {
    const t = new Date(card.createdOn).getTime();
    if (Number.isFinite(t)) {
      return t;
    }
  }
  const id = typeof card?.publicId === 'string' ? card.publicId.trim() : '';
  const m = id.match(/(\d{2})\.(\d{2})\.(\d{2})$/);
  if (m) {
    const t = new Date(2000 + Number(m[3]), Number(m[2]) - 1, Number(m[1])).getTime();
    if (Number.isFinite(t)) {
      return t;
    }
  }
  return NaN;
}

function energyCardLastUsedMs(card, lastUsedByClientId) {
  if (card?.lastUsedOn) {
    const t = new Date(card.lastUsedOn).getTime();
    if (Number.isFinite(t)) {
      return t;
    }
  }
  const clientKey = String(card?.energyCardClientId || '');
  const fromHistory = lastUsedByClientId?.get(clientKey);
  return Number.isFinite(fromHistory) ? fromHistory : NaN;
}

function sortEnergyCardsDesc(cards, { inProgressClientIds, lastUsedByClientId } = {}) {
  const flaggedCount = cards.filter(c => c?.hasInProgress).length;
  const useHistoryInProgress = inProgressClientIds && inProgressClientIds.size > 0;

  const isInProgress = card => {
    const clientKey = String(card?.energyCardClientId || '');
    if (useHistoryInProgress) {
      return inProgressClientIds.has(clientKey);
    }
    // Avoid treating the old API bug (all cards flagged) as "all in progress".
    return Boolean(card?.hasInProgress) && flaggedCount === 1;
  };

  return [...cards].sort((a, b) => {
    const aInProgress = isInProgress(a);
    const bInProgress = isInProgress(b);
    if (aInProgress !== bInProgress) {
      return aInProgress ? -1 : 1;
    }

    const aUsed = energyCardLastUsedMs(a, lastUsedByClientId);
    const bUsed = energyCardLastUsedMs(b, lastUsedByClientId);
    const aUsedValid = Number.isFinite(aUsed);
    const bUsedValid = Number.isFinite(bUsed);
    if (aUsedValid && bUsedValid && aUsed !== bUsed) {
      return bUsed - aUsed;
    }
    if (aUsedValid !== bUsedValid) {
      return aUsedValid ? -1 : 1;
    }

    const aCreated = energyCardCreatedMs(a);
    const bCreated = energyCardCreatedMs(b);
    const aCreatedValid = Number.isFinite(aCreated);
    const bCreatedValid = Number.isFinite(bCreated);
    if (aCreatedValid && bCreatedValid && aCreated !== bCreated) {
      return bCreated - aCreated;
    }
    if (aCreatedValid !== bCreatedValid) {
      return aCreatedValid ? -1 : 1;
    }
    const bLeft = isUahEnergyCard(b) ? Number(b?.remainingUah || 0) : Number(b?.remainingKwh || 0);
    const aLeft = isUahEnergyCard(a) ? Number(a?.remainingUah || 0) : Number(a?.remainingKwh || 0);
    return bLeft - aLeft;
  });
}

function historySessionKeysEqual(left, right) {
  if (left.size !== right.size) {
    return false;
  }

  for (const key of left) {
    if (!right.has(key)) {
      return false;
    }
  }

  return true;
}

// Component to handle stop button with station online status check
function HistoryStopButton({ portNumber, stopProcessCharging, hideSpinner, t }) {
  const [stopConfirmOpen, setStopConfirmOpen] = useState(false);
  const isStopping = !hideSpinner;
  const { data: stationStatus } = useGetStationStatusQuery(
    { stationNumber: portNumber },
    {
      skip: !portNumber,
      pollingInterval: 2000,
    }
  );

  const isOnline = stationStatus?.lastJob?.deviceOnline;

  // Don't show stop button if station is offline
  if (!isOnline) {
    return null;
  }

  return (
    <>
      <Button
        className={`historyPageButton ${getActionButtonLoadingClassName(isStopping)}`}
        disabled={isStopping}
        aria-busy={isStopping}
        onClick={() => setStopConfirmOpen(true)}
      >
        {isStopping ? <ActionButtonSpinner /> : <span className="historyPageButtonLabel">{t('stopButton')}</span>}
      </Button>
      <StopChargingConfirmModal
        modalOpen={stopConfirmOpen}
        setModalOpen={setStopConfirmOpen}
        onConfirm={() => stopProcessCharging(portNumber)}
        isLoading={isStopping}
      />
    </>
  );
}

export default function HistoryPage() {
  const navigate = useNavigate();

  const openAllFastStationsMap = () => {
    ReactGA.event({
      category: 'stations',
      action: 'all_fast_stations_from_history',
    });
    navigate('/?mapFilter=80kw');
  };

  const getLanguage = localStorage.getItem('i18nextLng');
  // eslint-disable-next-line no-unused-vars
  const [currentLanguage, setCurrentLanguage] = useState(getLanguage);
  const { clientId } = useGetClientId();
  const canRecoverBalance = isNativeShellApp();
  const [page, setPage] = useState(0);
  const [accumulatedItems, setAccumulatedItems] = useState([]);

  const {
    data: pageData,
    isFetching: isPageFetching,
    isLoading: isPageLoading,
  } = api.useGetHistoryPageQuery({ clientUiId: clientId, page }, { skip: !clientId });
  const { data: totalsData, isLoading: isTotalsLoading } = api.useGetHistoryTotalsQuery(clientId, {
    skip: !clientId,
  });
  const { data: activeEnergyCards } = useGetActiveEnergyCardsQuery(clientId, {
    skip: !clientId,
    pollingInterval: 7000,
  });

  useEffect(() => {
    setPage(0);
    setAccumulatedItems([]);
  }, [clientId]);

  useEffect(() => {
    if (!pageData?.items) {
      return;
    }

    if (page === 0) {
      setAccumulatedItems(pageData.items);
      return;
    }

    setAccumulatedItems(prev => {
      const ids = new Set(prev.map(item => item.chargingJobId).filter(Boolean));
      const toAdd = pageData.items.filter(item => !item.chargingJobId || !ids.has(item.chargingJobId));
      return [...prev, ...toAdd];
    });
  }, [pageData, page]);

  const historyData = useMemo(() => {
    if (isPageLoading && page === 0 && accumulatedItems.length === 0) {
      return null;
    }

    return accumulatedItems.map(item => {
      if (!item.startedOn && item.state === 'CANCELED' && item.createdOn) {
        return { ...item, startedOn: item.createdOn };
      }
      return item;
    });
  }, [accumulatedItems, isPageLoading, page]);
  const inProgressEcClientIds = useMemo(() => {
    const ids = new Set();
    for (const item of accumulatedItems) {
      if (item?.state !== 'IN_PROGRESS' && item?.state !== 'WAITING') {
        continue;
      }
      const ecClientId = getEnergyCardClientIdFromInvoice(item?.invoiceId);
      if (ecClientId) {
        ids.add(ecClientId);
      }
    }
    return ids;
  }, [accumulatedItems]);
  const inProgressEcPortByClientId = useMemo(() => {
    const map = new Map();
    for (const item of accumulatedItems) {
      if (item?.state !== 'IN_PROGRESS' && item?.state !== 'WAITING') {
        continue;
      }
      const ecClientId = getEnergyCardClientIdFromInvoice(item?.invoiceId);
      if (!ecClientId) {
        continue;
      }
      const port = item?.plugNumber ?? item?.stationNumber;
      if (port == null || port === '') {
        continue;
      }
      map.set(ecClientId, String(port));
    }
    return map;
  }, [accumulatedItems]);
  const ecLastUsedByClientId = useMemo(() => {
    const map = new Map();
    for (const item of accumulatedItems) {
      const ecClientId = getEnergyCardClientIdFromInvoice(item?.invoiceId);
      if (!ecClientId) {
        continue;
      }
      const t = new Date(item?.startedOn || item?.createdOn || 0).getTime();
      if (!Number.isFinite(t)) {
        continue;
      }
      const prev = map.get(ecClientId) || 0;
      if (t > prev) {
        map.set(ecClientId, t);
      }
    }
    return map;
  }, [accumulatedItems]);
  const formatTime = 'DD MMM HH:mm';

  const [stopCharging] = api.useLazyStopProcessChargingQuery();
  const [notifyBalanceRecoverClicked] = useNotifyBalanceRecoverClickedMutation();
  const [recoverBalanceFromReceipt, { isLoading: isRecoverLoading }] = useRecoverBalanceFromReceiptMutation();
  const [recoverModalOpen, setRecoverModalOpen] = useState(false);
  const [recoverError, setRecoverError] = useState(null);
  const [refundModalOpen, setRefundModalOpen] = useState(false);
  const [refundSession, setRefundSession] = useState({
    invoiceId: '',
    jobId: null,
    stationNumber: '',
  });

  const { t } = useTranslation();

  const RECOVER_BALANCE_FORM_URL = 'https://forms.gle/MSpRHe3Yuez4u71c7';
  const handleRecoverBalanceClick = () => {
    if (clientId) {
      notifyBalanceRecoverClicked(clientId);
    }
    window.open(RECOVER_BALANCE_FORM_URL, '_blank');
  };

  const handleRecoverBalanceAutomatically = () => {
    if (!canRecoverBalance) return;
    setRecoverError(null);
    setRecoverModalOpen(true);
  };

  const openRefundForSession = session => {
    ReactGA.event({
      category: 'refund_request',
      action: 'open from history',
      label: String(session?.stationNumber || ''),
    });
    setRefundSession({
      invoiceId: session?.invoiceId || '',
      jobId: session?.jobId ?? null,
      stationNumber: String(session?.stationNumber || ''),
    });
    setRefundModalOpen(true);
  };

  /** Always-available refund entry (new phone / no local session). */
  const openRefundRequest = () => {
    ReactGA.event({
      category: 'refund_request',
      action: 'open from history footer',
      label: 'manual',
    });
    setRefundSession({ invoiceId: '', jobId: null, stationNumber: '' });
    setRefundModalOpen(true);
  };

  const handleRecoverUpload = async file => {
    if (!canRecoverBalance || !clientId || !file) return;
    setRecoverError(null);
    try {
      const result = await recoverBalanceFromReceipt({
        clientUiId: clientId,
        file,
      }).unwrap();
      if (result.success) {
        setRecoverModalOpen(false);
        window.location.reload();
      } else {
        setRecoverError(result.error || 'UNKNOWN');
      }
    } catch (err) {
      const errorCode =
        err?.data?.error ||
        (err?.status === 429
          ? 'RATE_LIMITED'
          : err?.status === 403
            ? 'NATIVE_APP_REQUIRED'
            : err?.status === 404
              ? 'ORDER_NOT_FOUND'
              : 'PARSE_FAILED');
      setRecoverError(errorCode);
    }
  };
  const urlProtocol = window.location.protocol;
  const urlHost = window.location.host;
  const [hideSpinner, setHideSpinner] = useState(true);
  const [copyFeedback, setCopyFeedback] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState(() => new Set());
  const [expandedEnergyCardKeys, setExpandedEnergyCardKeys] = useState(() => new Set());
  const [archivedEnergyCardsExpanded, setArchivedEnergyCardsExpanded] = useState(false);
  const [showClientQr, setShowClientQr] = useState(false);
  const [showPreviousMonths, setShowPreviousMonths] = useState(false);
  const [revenueChartExpanded, setRevenueChartExpanded] = useState(false);
  const [revenueChartReady, setRevenueChartReady] = useState(false);

  function isIos() {
    return (
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on isIos 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }

  function getDeviceType() {
    const userAgent = getClientAgent();
    if (userAgent.includes('iPhone')) return 'iPhone';
    if (userAgent.includes('iPad')) return 'iPad';
    if (userAgent.includes('iPod')) return 'iPod';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('Windows')) return 'Windows';
    if (userAgent.includes('Mac OS X') || userAgent.includes('Macintosh')) return 'macOS';
    if (userAgent.includes('Linux')) return 'Linux';
    return 'Unknown';
  }

  function formatClientId(clientId) {
    const deviceType = getDeviceType();
    const formattedId = String(clientId ?? '').trim();
    const label = isNativeShellApp() ? `${deviceType}_native` : deviceType;
    return `#${label}_${formattedId}`;
  }

  async function handleCopyClientId() {
    const text = formatClientId(clientId);
    try {
      await navigator.clipboard.writeText(text);
      setCopyFeedback(true);
      setTimeout(() => setCopyFeedback(false), 2000);
    } catch {
      setCopyFeedback(false);
    }
  }

  async function stopProcessCharging(portNumber) {
    setHideSpinner(false);

    const { isSuccess, error } = await stopCharging({ portNumber });
    if (isSuccess) {
      window.location.href = `/charging?station=${portNumber}`;
    } else if (error) {
      console.error(error);
      setHideSpinner(true);
    }
  }

  useEffect(() => {
    setCurrentLanguage(getLanguage);
    moment.locale(getLanguage);
  }, [getLanguage]);

  useEffect(() => {
    document.body.classList.add('b2b-route');
    const layout = document.getElementById('layout');
    layout?.classList.add('b2b-route-layout');
    return () => {
      document.body.classList.remove('b2b-route');
      layout?.classList.remove('b2b-route-layout');
    };
  }, []);

  useEffect(() => {
    let active = true;

    waitForHistoryChartFonts().finally(() => {
      if (active) {
        setRevenueChartReady(true);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (!historyData) {
      return;
    }

    setExpandedKeys(prev => {
      const next = new Set();
      historyData.forEach((item, index) => {
        const sessionKey = getHistorySessionKey(item, index);
        if (prev.has(sessionKey) || item.state === 'IN_PROGRESS') {
          next.add(sessionKey);
        }
      });
      return historySessionKeysEqual(prev, next) ? prev : next;
    });
  }, [historyData]);

  // Helper: aggregate revenue, kWh and duration by month (from backend totals)
  const monthlyData = totalsData?.monthlyStats ?? [];
  const maxMonths = 24;
  const lastN = monthlyData.slice(-maxMonths);
  const canShowPreviousMonths = lastN.length >= REVENUE_CHART_MONTHS * 2;
  const visibleData =
    showPreviousMonths && canShowPreviousMonths
      ? lastN.slice(-REVENUE_CHART_MONTHS * 2, -REVENUE_CHART_MONTHS)
      : lastN.slice(-REVENUE_CHART_MONTHS);
  const hasRevenueChartData = lastN.some(d => d.kwh > 0);
  const totalChargedKwh = totalsData?.totalKwh ?? 0;
  const reincarnatedLiters = totalsData?.litersSaved ?? 0;
  const savedCo2Kg = totalsData?.co2KgSaved ?? 0;
  const hasMoreSessions = pageData?.hasMore ?? false;

  function handleLoadMoreSessions() {
    if (hasMoreSessions && !isPageFetching) {
      setPage(prev => prev + 1);
    }
  }

  const barData = {
    labels: visibleData.map(d => getShortMonthLabel(d.month, t)),
    datasets: [
      {
        label: t('wt'),
        data: visibleData.map(d => d.kwh),
        backgroundColor: 'rgba(249, 76, 175, 0.88)',
        borderRadius: {
          topLeft: 8,
          topRight: 8,
          bottomLeft: 0,
          bottomRight: 0,
        },
        maxBarThickness: 48,
        datalabels: {
          display: false,
        },
      },
    ],
  };
  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 8,
        right: 10,
        bottom: 4,
        left: 2,
      },
    },
    interaction: {
      intersect: true,
      mode: 'index',
    },
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: {
        enabled: false,
        external: createRevenueChartExternalTooltip(visibleData, t),
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: 'rgba(218, 209, 230, 0.72)',
          font: {
            family: HISTORY_CHART_FONT,
            size: 10,
            weight: '700',
          },
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false,
        },
        title: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        afterFit(axis) {
          axis.width = 52;
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.08)',
        },
        ticks: {
          color: '#dad1e6',
          font: {
            family: HISTORY_CHART_FONT,
            size: 11,
            weight: '700',
          },
          callback: value => Math.round(Number(value)),
        },
        title: {
          display: true,
          text: t('wt'),
          color: 'rgba(218, 209, 230, 0.8)',
          font: {
            family: HISTORY_CHART_FONT,
            size: 12,
            weight: '700',
          },
        },
      },
    },
    animation: false,
  };

  const renderPageShell = content => (
    <div className={`${gammaThemeStyles.b2bPageRoot} historyPageRoot`}>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link rel="stylesheet" href={B2B_GAMMA_FONTS} />
      </Helmet>
      {content}
      <ClientIdQrModal modalOpen={showClientQr} setModalOpen={setShowClientQr} clientId={clientId} />
    </div>
  );

  const toggleEnergyCardExpanded = cardKey => {
    setExpandedEnergyCardKeys(prev => {
      const next = new Set(prev);
      if (next.has(cardKey)) {
        next.delete(cardKey);
      } else {
        next.add(cardKey);
      }
      return next;
    });
  };

  const renderEnergyCardDetails = (card, { chargingPort } = {}) => {
    const { cardId } = getEnergyCardDisplayMeta(card, t);
    const ports = card.stationNumbers || [];
    return (
      <div className="historyEnergyCardDetails">
        {cardId && (
          <Typography component="p" className="historyEnergyCardId">
            {t('energyCard.cardId')}: {cardId}
          </Typography>
        )}
        <Typography component="p" className="historyEnergyCardBalance">
          {isUahEnergyCard(card)
            ? `${Number(card.remainingUah || 0).toFixed(2)} ${t('energyCard.uahForPorts')}`
            : `${Number(card.remainingKwh || 0).toFixed(1)} ${t('energyCard.kwhForPorts')}`}
        </Typography>
        {chargingPort && (
          <Button
            className="historyPageButton historyEnergyCardChargingPortBtn blink_me"
            onClick={e => {
              e.stopPropagation();
              navigate(`/charging?station=${chargingPort}`);
            }}
          >
            <span className="historyEnergyCardChargingPortBtnLabel">
              {t('historyPage.openPort')}
              <span className="historyEnergyCardChargingPortBtnNumber">{chargingPort}</span>
            </span>
          </Button>
        )}
        <Typography component="p" className="historyEnergyCardPorts">
          {ports
            .map(n => {
              const portLabel = `#${n}`;
              const isOpenPort = chargingPort != null && String(n) === String(chargingPort);
              return (
                <button
                  key={portLabel}
                  type="button"
                  className={
                    isOpenPort ? 'historyEnergyCardPort historyEnergyCardPort--open blink_me' : 'historyEnergyCardPort'
                  }
                  aria-label={t('portCardOpenStartManyAria', { stationNumber: n })}
                  onClick={e => {
                    e.stopPropagation();
                    navigate(`/startMany?ports=${encodeURIComponent(String(n))}`);
                  }}
                >
                  {portLabel}
                </button>
              );
            })
            .reduce((acc, node, idx) => {
              if (idx === 0) {
                return [node];
              }
              return [...acc, ', ', node];
            }, [])}
        </Typography>
        {ports.length > 0 && (
          <Typography component="p" className="historyEnergyCardPortsHint">
            {t('energyCard.clickPortForDetails')}
          </Typography>
        )}
        {card.expiresOn && (
          <Typography component="p" className="historyEnergyCardExpires">
            {t('energyCard.validUntil')} {formatEnergyCardExpiresOn(card.expiresOn)}
          </Typography>
        )}
      </div>
    );
  };

  const renderEnergyCardAccordion = card => {
    const cardKey = String(card.energyCardId || card.energyCardClientId);
    const ecClientKey = String(card.energyCardClientId || '');
    // Prefer live history match; API used to mark ALL cards when any EC session is active.
    const flaggedActiveCount = (activeEnergyCards || []).filter(c => !c.expired && c.hasInProgress).length;
    const inProgress =
      inProgressEcClientIds.size > 0
        ? inProgressEcClientIds.has(ecClientKey)
        : Boolean(card.hasInProgress) && flaggedActiveCount === 1;
    const chargingPort = inProgress ? inProgressEcPortByClientId.get(ecClientKey) : undefined;
    // Keep charging card expanded.
    const expanded = inProgress || expandedEnergyCardKeys.has(cardKey);
    const { displayName } = getEnergyCardDisplayMeta(card, t);
    const remainingLabel = isUahEnergyCard(card)
      ? `${Number(card.remainingUah || 0).toFixed(0)} ${t('currency').trim()}`
      : `${Number(card.remainingKwh || 0).toFixed(1)} ${t('wt')}`;
    return (
      <AccordionCustom
        key={cardKey}
        className={['historyEnergyCardAccordion', inProgress ? 'historyEnergyCardAccordion--inProgress' : '']
          .filter(Boolean)
          .join(' ')}
        expanded={expanded}
        onChange={() => {
          if (inProgress) {
            return;
          }
          toggleEnergyCardExpanded(cardKey);
        }}
      >
        <AccordionSummaryCustom
          className="historyEnergyCardSummary"
          expandIcon={<ExpandMoreIconCustom />}
          aria-controls={`ec-${cardKey}-content`}
          id={`ec-${cardKey}-header`}
        >
          <Typography component="div" className="historyEnergyCardSummaryText">
            <span className={`historyEnergyCardAmount${inProgress ? ' blink_me' : ''}`}>{displayName}</span>
            <span
              className={`historyEnergyCardSummaryBalance${inProgress ? ' historyEnergyCardSummaryBalance--charging blink_me' : ''}`}
            >
              {remainingLabel}
            </span>
          </Typography>
        </AccordionSummaryCustom>
        <AccordionDetailsCustom className="historyEnergyCardAccordionDetails">
          {renderEnergyCardDetails(card, { chargingPort })}
        </AccordionDetailsCustom>
      </AccordionCustom>
    );
  };

  const renderEnergyCardsSection = () => {
    if (!activeEnergyCards?.length) {
      return null;
    }
    const sortOpts = {
      inProgressClientIds: inProgressEcClientIds,
      lastUsedByClientId: ecLastUsedByClientId,
    };
    const activeCards = sortEnergyCardsDesc(
      activeEnergyCards.filter(card => !card.expired),
      sortOpts
    );
    const archivedCards = sortEnergyCardsDesc(
      activeEnergyCards.filter(card => card.expired),
      sortOpts
    );
    if (!activeCards.length && !archivedCards.length) {
      return null;
    }
    return (
      <section className="historyEnergyCardsSection" aria-label={t('energyCard.label')}>
        {activeCards.map(renderEnergyCardAccordion)}
        {archivedCards.length > 0 && (
          <AccordionCustom
            className="historyEnergyCardAccordion historyEnergyCardAccordion--archived"
            expanded={archivedEnergyCardsExpanded}
            onChange={(_, isExpanded) => setArchivedEnergyCardsExpanded(isExpanded)}
          >
            <AccordionSummaryCustom
              className="historyEnergyCardSummary"
              expandIcon={<ExpandMoreIconCustom />}
              aria-controls="ec-archived-content"
              id="ec-archived-header"
            >
              <Typography component="div" className="historyEnergyCardSummaryText">
                <span className="historyEnergyCardAmount">{t('energyCard.archived')}</span>
                <span className="historyEnergyCardSummaryBalance">{archivedCards.length}</span>
              </Typography>
            </AccordionSummaryCustom>
            <AccordionDetailsCustom className="historyEnergyCardAccordionDetails">
              {archivedCards.map(renderEnergyCardAccordion)}
            </AccordionDetailsCustom>
          </AccordionCustom>
        )}
      </section>
    );
  };

  const renderClientIdentitySection = () => (
    <section className="historyHeroSection" aria-label={t('historyPage.clientUiId')}>
      <button
        type="button"
        className="historyQrTopButton"
        onClick={() => setShowClientQr(true)}
        aria-label={t('historyPage.createFamily')}
        title={t('historyPage.createFamily')}
      >
        <span className="historyQrTopButtonLabel">{t('historyPage.createFamily')}</span>
      </button>
      <div className="historyClientBlock">
        <Typography component="p" className="historyClientIdLabel">
          {t('historyPage.clientUiId')}
        </Typography>
        <Typography
          component="span"
          onClick={handleCopyClientId}
          role="button"
          tabIndex={0}
          onKeyDown={e => e.key === 'Enter' && handleCopyClientId()}
          className="historyClientIdValue"
        >
          {formatClientId(clientId)}
        </Typography>
        {copyFeedback && (
          <Typography component="span" className="historyCopyFeedback">
            {t('historyPage.copiedToClipboard')}
          </Typography>
        )}
      </div>
    </section>
  );

  if (!historyData || isTotalsLoading) {
    return <Spinner pageCentered />;
  }

  if (historyData.length === 0) {
    return renderPageShell(
      <Container className="p-0 pt-3 pb-5 historyPageContainer">
        {/* All Cards Grouped Together */}
        <Box className="historyPageInner">
          {/* Client Info Cards */}
          {renderClientIdentitySection()}
          {renderEnergyCardsSection()}

          <section className="historyEmptyBlock" aria-labelledby="history-empty-title">
            <p id="history-empty-title" className="historyEmptyState">
              {t('historyEmpty')}
            </p>
            <div className="historyButtonStack historyEmptyActions">
              {canRecoverBalance && (
                <Button className="historyPageButton" onClick={handleRecoverBalanceAutomatically}>
                  <span className="historyPageButtonLabel">{t('recoverBalance')}</span>
                </Button>
              )}
              <Button type="button" className="historyPageButton historyStationButton" onClick={openRefundRequest}>
                <span className="historyPageButtonLabel">{t('refundForm.button')}</span>
              </Button>
            </div>
          </section>

          {canRecoverBalance && (
            <RecoverBalanceModal
              modalOpen={recoverModalOpen}
              setModalOpen={setRecoverModalOpen}
              onUpload={handleRecoverUpload}
              onManualRecover={handleRecoverBalanceClick}
              isLoading={isRecoverLoading}
              error={recoverError}
            />
          )}
          <RefundRequestModal
            modalOpen={refundModalOpen}
            setModalOpen={setRefundModalOpen}
            stationNumber={refundSession.stationNumber}
            clientId={clientId}
            invoiceId={refundSession.invoiceId}
            jobId={refundSession.jobId}
            onRecoverBalance={canRecoverBalance ? handleRecoverBalanceAutomatically : undefined}
          />

          {/* Telegram Bot Button */}
          <Row className="justify-content-center">
            <Col xs={12} sm={8} md={6} lg={4}>
              <Col
                as={'a'}
                href={`https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId)}-history`}
                className="text-center telegram historyTelegramCard"
                onClick={() => {
                  ReactGA.event({
                    category: 'telegram',
                    action: 'telegram_from_history_empty',
                  });
                }}
              >
                <FontAwesomeIcon icon={faTelegram} size="3x" className="historyTelegramIcon" />
                <Typography
                  className="historyTelegramTitle"
                  style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px' }}
                >
                  {t('telegram')}
                </Typography>
                <Typography
                  className="historyTelegramHint"
                  style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}
                >
                  {t('tapChatBot')}
                </Typography>
              </Col>
            </Col>
          </Row>

          {/* Stations Section for empty history */}
          <div className="historyStationsSection">
            <div className="historyButtonStack historySectionDivider">
              <Button className="historyPageButton historyStationButton" onClick={openAllFastStationsMap}>
                <span className="historyPageButtonLabel">{t('allStations80Plus')}</span>
              </Button>
              <Button
                className="historyPageButton historyStationButton"
                onClick={() => {
                  ReactGA.event({
                    category: 'stations',
                    action: 'all_stations_evboost_from_history_empty',
                  });
                  window.open('https://www.evboost.com.ua/', '_blank', 'noopener,noreferrer');
                }}
              >
                <span className="historyPageButtonLabel">{t('allStationsEvboost')}</span>
              </Button>
            </div>
          </div>
        </Box>
      </Container>
    );
  }

  return renderPageShell(
    <Container className="p-0 pt-3 pb-5 historyPageContainer">
      {/* Client Info and Chart Container */}
      <Box className="historyPageInner">
        {renderClientIdentitySection()}
        {/* Totals / Підсумки above Energy Cards */}
        {hasRevenueChartData && (
          <section className="historyRevenueChartSection" aria-label={t('historyPage.revenueChartMonthAxis')}>
            <div className={powerCurveStyles.chartCard}>
              <button
                type="button"
                className={`historyRevenueChartToggle${revenueChartExpanded ? ' historyRevenueChartToggleExpanded' : ''}`}
                onClick={() => setRevenueChartExpanded(prev => !prev)}
                aria-expanded={revenueChartExpanded}
                aria-controls="historyRevenueChartPanel"
              >
                <span className="historyRevenueChartToggleTitle">{t('historyPage.revenueChartSummaryAria')}</span>
                <ExpandMoreIconCustom className="historyRevenueChartToggleIcon" aria-hidden />
              </button>

              {revenueChartExpanded && (
                <div id="historyRevenueChartPanel" className="historyRevenueChartPanel">
                  <div
                    className="historyRevenueChartControls"
                    role="group"
                    aria-label={t('historyPage.revenueChartMonthAxis')}
                  >
                    <button
                      type="button"
                      className={`historyRevenueChartSwitch ${!showPreviousMonths ? 'historyRevenueChartSwitchActive' : ''}`}
                      onClick={() => setShowPreviousMonths(false)}
                    >
                      {t('historyPage.revenueChartLast6Months')}
                    </button>
                    <button
                      type="button"
                      className={`historyRevenueChartSwitch ${showPreviousMonths ? 'historyRevenueChartSwitchActive' : ''}`}
                      onClick={() => setShowPreviousMonths(true)}
                      disabled={!canShowPreviousMonths}
                    >
                      {t('historyPage.revenueChartPrevious6Months')}
                    </button>
                  </div>
                  <div className={powerCurveStyles.powerCurvePlot}>
                    <div className="historyRevenueChartBox">
                      {revenueChartReady && <Bar data={barData} options={barOptions} />}
                    </div>
                  </div>
                </div>
              )}

              <ul
                className={`historyRevenueChartSummary${revenueChartExpanded ? '' : ' historyRevenueChartSummaryCollapsed'}`}
                aria-label={t('historyPage.revenueChartSummaryAria')}
              >
                <li className="historyRevenueChartSummaryRow">
                  <span className="historyRevenueChartSummaryLabel">{t('historyPage.revenueChartTotalCharged')}</span>
                  <span className="historyRevenueChartSummaryValue">
                    {formatHistoryKwh(totalChargedKwh)} {t('wt')}
                  </span>
                </li>
                <li className="historyRevenueChartSummaryRow">
                  <span className="historyRevenueChartSummaryLabel">{t('getBloodyLitersSaved')}</span>
                  <a
                    href={t('bloodyLitersLink')}
                    className="historyRevenueChartSummaryValue historyRevenueChartSummaryLink"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {formatImpactCount(reincarnatedLiters)} {t('historyPage.revenueChartLitersUnit')}
                  </a>
                </li>
                <li className="historyRevenueChartSummaryRow">
                  <span className="historyRevenueChartSummaryLabel">{t('historyPage.revenueChartSavedCo2')}</span>
                  <span className="historyRevenueChartSummaryValue">
                    {formatImpactCo2Tons(savedCo2Kg)} {t('historyPage.revenueChartCo2Unit')}
                  </span>
                </li>
              </ul>
            </div>
          </section>
        )}
        {renderEnergyCardsSection()}
      </Box>
      {/* History List */}
      {historyData.map(
        (
          {
            plugNumber: portNumber,
            chargingJobId,
            startedOn,
            priceInCents,
            durationSeconds,
            energyWth,
            finishedOn,
            refundedCents,
            bankRefundedCents,
            balanceCents,
            state,
            address,
            plugType,
            invoiceId,
            createdOn,
          },
          index
        ) => {
          const sessionKey = getHistorySessionKey(
            {
              plugNumber: portNumber,
              chargingJobId,
              startedOn,
              invoiceId,
              createdOn,
            },
            index
          );

          function defineTime() {
            const remainingHours = Math.floor(durationSeconds / 3600);
            const remainingMinutes = Math.round((durationSeconds % 3600) / 60);

            if (remainingHours <= 0) {
              return (
                <>
                  <span className="historyMetricNumber">{remainingMinutes}</span>
                  <span className="historyMetricUnit"> {t('historyPage.timeMinutes')}</span>
                </>
              );
            }

            return (
              <>
                <span className="historyMetricNumber">{remainingHours}</span>
                <span className="historyMetricUnit"> {t('historyPage.timeHours')}</span>
                <span className="historyMetricUnit"> : </span>
                <span className="historyMetricNumber">{remainingMinutes}</span>
                <span className="historyMetricUnit"> {t('historyPage.timeMinutes')}</span>
              </>
            );
          }

          return (
            <AccordionCustom
              key={sessionKey}
              className="historyAccordion"
              style={{ margin: '0px 30px' }}
              expanded={expandedKeys.has(sessionKey)}
              onChange={(_, isExpanded) => {
                setExpandedKeys(prev => {
                  const next = new Set(prev);
                  if (isExpanded) {
                    next.add(sessionKey);
                  } else {
                    next.delete(sessionKey);
                  }
                  return next;
                });
              }}
            >
              <AccordionSummaryCustom
                className="historyAccordionSummary"
                expandIcon={<ExpandMoreIconCustom />}
                aria-controls={'panel1a-content'}
                id={'panel1a-header'}
              >
                <Typography
                  component="div"
                  className="w-100 d-flex justify-content-between historyAccordionHeading"
                  style={{ fontSize: '1em' }}
                >
                  <span>{moment(startedOn).format(formatTime)} </span>
                  {bankRefundedCents > 0 ? (
                    <span style={{ color: 'var(--history-success)', fontSize: '0.9em' }}>
                      {t('historyPage.bankRefundSuccess')} {bankRefundedCents / 100} {t('currency')}
                    </span>
                  ) : state === 'TOP_UP_BALANCE' ? (
                    <span style={{ color: 'var(--history-success)' }}>
                      + {refundedCents / 100} {t('currency')}
                    </span>
                  ) : null}
                  <span className={state === 'IN_PROGRESS' ? 'blink_me' : undefined}>
                    <span
                      style={{
                        marginLeft: '5px',
                        fontSize: state === 'IN_PROGRESS' ? '1.5em' : '1em',
                        fontWeight: state === 'IN_PROGRESS' ? 600 : undefined,
                        color:
                          state === 'IN_PROGRESS'
                            ? 'var(--history-balance-accent, #0066ff)'
                            : (energyWth === 0 && durationSeconds > 600) || state === 'CANCELED'
                              ? '#ff7f9f'
                              : undefined,
                        textShadow: state === 'IN_PROGRESS' ? '0 0 10px rgba(0, 102, 255, 0.55)' : undefined,
                        transition: 'all 0.3s ease',
                      }}
                    >
                      {(energyWth / 1000).toFixed(1)} {t('wt')}
                    </span>
                  </span>
                </Typography>
              </AccordionSummaryCustom>
              <AccordionDetailsCustom className="historyAccordionDetails" style={{ padding: '16px 12px' }}>
                <Button className="historyPageButton" onClick={() => navigate(`/start?station=${portNumber}`)}>
                  <span
                    className="portInfo historyOpenPortText"
                    style={{ textAlign: 'center', width: '100%', display: 'block' }}
                  >
                    {t('historyPage.openPort')}
                    <span style={{ fontWeight: 700, marginInline: '0.3rem' }}>{portNumber}</span>
                    {plugType && (
                      <>
                        <span style={{ marginInline: '0.3rem' }}>&gt;&gt;</span>
                        <span className="historyPlugTypeBadge">{plugTypeMaping[plugType]}</span>
                      </>
                    )}
                  </span>
                </Button>
                {state === 'IN_PROGRESS' && (
                  <HistoryStopButton
                    portNumber={portNumber}
                    stopProcessCharging={stopProcessCharging}
                    hideSpinner={hideSpinner}
                    t={t}
                  />
                )}
                <Card
                  variant=""
                  className="historyCard historyMetricCard"
                  style={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBlock: '8px',
                    padding: '12px 16px',
                  }}
                >
                  <span
                    className="portInfo historyMetricText"
                    style={{ textAlign: 'center', width: '100%', display: 'block' }}
                  >
                    {t('historyPage.price')}:&nbsp;
                    <span className="historyMetricNumber">{(priceInCents / 100).toFixed(2)}</span>
                    <span className="historyMetricUnit">{t('currency')}</span>
                  </span>
                </Card>
                {state !== 'IN_PROGRESS' && (
                  <Card
                    variant=""
                    className="historyCard historyMetricCard"
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBlock: '8px',
                      padding: '12px 16px',
                    }}
                  >
                    <span
                      className="portInfo historyMetricText"
                      style={{ textAlign: 'center', width: '100%', display: 'block' }}
                    >
                      {balanceCents === 0 ? t('historyPage.refund') : t('historyPage.balance')}:&nbsp;
                      <span className="historyMetricNumber">
                        {((balanceCents === 0 ? refundedCents : balanceCents) / 100).toFixed(2)}
                      </span>
                      <span className="historyMetricUnit">{t('currency')}</span>
                    </span>
                  </Card>
                )}
                {bankRefundedCents > 0 && (
                  <Card
                    variant=""
                    className="historyCard historyMetricCard"
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBlock: '8px',
                      padding: '12px 16px',
                      borderColor: 'var(--history-success, #2ecc71)',
                    }}
                  >
                    <span
                      className="portInfo historyMetricText"
                      style={{ textAlign: 'center', width: '100%', display: 'block' }}
                    >
                      {t('historyPage.bankRefund')}:&nbsp;
                      <span className="historyMetricNumber" style={{ color: 'var(--history-success)' }}>
                        {(bankRefundedCents / 100).toFixed(2)}
                      </span>
                      <span className="historyMetricUnit">{t('currency')}</span>
                    </span>
                  </Card>
                )}
                <Card
                  variant=""
                  className="historyCard historyMetricCard"
                  style={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBlock: '8px',
                    padding: '12px 16px',
                  }}
                >
                  <span
                    className="portInfo historyMetricText"
                    style={{ textAlign: 'center', width: '100%', display: 'block' }}
                  >
                    {t('historyPage.amountS')}:&nbsp;
                    <span className={state === 'IN_PROGRESS' ? 'blink_me' : undefined}>{defineTime()}</span>
                  </span>
                </Card>
                <Card
                  variant=""
                  className="historyCard historyMetricCard"
                  style={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBlock: '8px',
                    padding: '12px 16px',
                  }}
                >
                  <span
                    className="portInfo historyMetricText"
                    style={{ textAlign: 'center', width: '100%', display: 'block' }}
                  >
                    {t('historyPage.avgPower')}:&nbsp;
                    <span className="historyMetricNumber">
                      {(computeSessionAvgPowerKw(energyWth, durationSeconds) ?? 0).toFixed(1)}
                    </span>
                    <span className="historyMetricUnit"> {t('kW')}</span>
                  </span>
                </Card>
                <HistoryPowerCurve
                  jobId={chargingJobId}
                  clientUiId={clientId}
                  state={state}
                  durationSeconds={durationSeconds}
                  energyWth={energyWth}
                  expanded={expandedKeys.has(sessionKey)}
                  plugType={plugType}
                  stationNumber={portNumber}
                />
                {address && (
                  <Card
                    variant=""
                    className="historyCard historyMetricCard"
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBlock: '8px',
                      padding: '12px 16px',
                    }}
                  >
                    <span
                      className="portInfo historyMetricText"
                      style={{ textAlign: 'center', width: '100%', display: 'block' }}
                    >
                      {address}
                    </span>
                  </Card>
                )}
                {invoiceId && !invoiceId.includes('___liquidBalance___') && (
                  <Card
                    variant=""
                    className="historyCard historyMetricCard"
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBlock: '8px',
                      padding: '12px 16px',
                    }}
                  >
                    <a
                      href={`${HOST}:${PORT}/api/v2/history/getReceipt?invoiceId=${encodeURIComponent(invoiceId)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={e => {
                        // Android WebView silently drops <a target="_blank"> clicks because
                        // multi-window support is intentionally disabled. Route through the
                        // native bridge so the receipt PDF opens in the system browser.
                        if (window.AndroidInterface?.openExternal) {
                          e.preventDefault();
                          window.AndroidInterface.openExternal(
                            `${HOST}:${PORT}/api/v2/history/getReceipt?invoiceId=${encodeURIComponent(invoiceId)}`
                          );
                        }
                      }}
                      className="historyLink historyReceiptLink"
                      style={{ fontSize: '1.2em', border: 'none', background: 'none', cursor: 'pointer' }}
                    >
                      {t('historyPage.receipt')}
                    </a>
                  </Card>
                )}
                {state !== 'IN_PROGRESS' &&
                  Number(energyWth || 0) === 0 &&
                  invoiceId &&
                  !invoiceId.includes('___liquidBalance___') &&
                  !isEnergyCardInvoiceId(invoiceId) &&
                  !(Number(bankRefundedCents || 0) > 0) && (
                    <Button
                      type="button"
                      className="historyPageButton historyStationButton"
                      onClick={() =>
                        openRefundForSession({
                          invoiceId,
                          jobId: chargingJobId,
                          stationNumber: portNumber,
                        })
                      }
                    >
                      <span className="historyPageButtonLabel">{t('refundForm.button')}</span>
                    </Button>
                  )}
                {state !== 'IN_PROGRESS' && (
                  <Button className="historyPageButton" onClick={() => navigate(`/start?station=${portNumber}`)}>
                    <span className="historyPageButtonLabel">{t('startNew')}</span>
                  </Button>
                )}
              </AccordionDetailsCustom>
            </AccordionCustom>
          );
        }
      )}

      {hasMoreSessions && (
        <div className="historyLoadMoreWrap">
          <Button
            className={`historyPageButton historyLoadMoreButton ${getActionButtonLoadingClassName(isPageFetching)}`}
            disabled={isPageFetching}
            aria-busy={isPageFetching}
            onClick={handleLoadMoreSessions}
          >
            {isPageFetching ? (
              <ActionButtonSpinner />
            ) : (
              <span className="historyPageButtonLabel">{t('historyPage.loadOlderSessions')}</span>
            )}
          </Button>
        </div>
      )}

      {/* Telegram Bot Button */}
      <Box className="historyFooterActions">
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Col
              as={'a'}
              href={`https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId)}-history`}
              className="text-center telegram historyTelegramCard"
              onClick={() => {
                ReactGA.event({
                  category: 'telegram',
                  action: 'telegram_from_history',
                });
              }}
            >
              <FontAwesomeIcon icon={faTelegram} size="3x" className="historyTelegramIcon" />
              <Typography
                className="historyTelegramTitle"
                style={{ fontSize: '18px', fontWeight: 'bold', letterSpacing: '1px' }}
              >
                {t('telegram')}
              </Typography>
              <Typography
                className="historyTelegramHint"
                style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}
              >
                {t('tapChatBot')}
              </Typography>
            </Col>
          </Col>
        </Row>

        <div className="historyButtonStack" style={{ marginTop: '20px' }}>
          {canRecoverBalance && (
            <Button className="historyPageButton" onClick={handleRecoverBalanceAutomatically}>
              <span className="historyPageButtonLabel">{t('recoverBalance')}</span>
            </Button>
          )}
          <Button type="button" className="historyPageButton historyStationButton" onClick={openRefundRequest}>
            <span className="historyPageButtonLabel">{t('refundForm.button')}</span>
          </Button>
        </div>
      </Box>

      {canRecoverBalance && (
        <RecoverBalanceModal
          modalOpen={recoverModalOpen}
          setModalOpen={setRecoverModalOpen}
          onUpload={handleRecoverUpload}
          onManualRecover={handleRecoverBalanceClick}
          isLoading={isRecoverLoading}
          error={recoverError}
        />
      )}
      <RefundRequestModal
        modalOpen={refundModalOpen}
        setModalOpen={setRefundModalOpen}
        stationNumber={refundSession.stationNumber}
        clientId={clientId}
        invoiceId={refundSession.invoiceId}
        jobId={refundSession.jobId}
        onRecoverBalance={canRecoverBalance ? handleRecoverBalanceAutomatically : undefined}
      />

      {/* Stations Section */}
      <div className="historyStationsSection">
        <div className="historyButtonStack historySectionDivider">
          <Button className="historyPageButton historyStationButton" onClick={openAllFastStationsMap}>
            <span className="historyPageButtonLabel">{t('allStations80Plus')}</span>
          </Button>
          <Button
            className="historyPageButton historyStationButton"
            onClick={() => {
              ReactGA.event({
                category: 'stations',
                action: 'all_stations_evboost_from_history',
              });
              window.open('https://www.evboost.com.ua/', '_blank', 'noopener,noreferrer');
            }}
          >
            <span className="historyPageButtonLabel">{t('allStationsEvboost')}</span>
          </Button>
        </div>
      </div>
    </Container>
  );
}
